<template>
  <section class="auto-complete">
    <input
      ref="field"
      :value="search"
      @input="e => search = e.target.value"
      @focus="focusInput"
      @blur="closeDrop"
      :class="css"
      type="text"
      v-bind="$attrs"
    />
    <div
      class="auto-list"
      :class="{ show : openDrop }"
      :style="`width: ${$refs.field && $refs.field.clientWidth || 0}px`"
    >
      <div
        v-for="(item, i) in filteredList"
        @click="selectItem(item, $event)"
        :key="i"
        class="auto-list-item"
      >
        <span>{{ item.name }}</span>
        <span v-if="item.detail">{{ item.detail }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['value', 'list', 'css'],
  data () {
    return {
      search: '',
      openDrop: false
    }
  },
  computed: {
    filteredList () {
      return this.list.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    value (value) {
      this.search = value ? this.list.find(x => x.id === value).name : ''
    }
  },
  methods: {
    selectItem (value) {
      this.$emit('input', value.id)
      this.$emit('change', value.id)
      this.openDrop = false
    },
    closeDrop () {
      setTimeout(() => { this.openDrop = false }, 200)
    },
    focusInput ($event) {
      $event.target.select()
      this.openDrop = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.auto-complete {
  position: relative;

  input {
    width: 100%;
    box-sizing: border-box;
    text-transform: capitalize;
  }

  &.error {
    input {
      border: 1px solid $error-color;
      background-color: rgba(136, 0, 0, 0.1);
    }
  }

  .auto-list {
    box-sizing: border-box;
    background-color: $lp-panel-2;
    border: 1px solid $lp-border-strong;
    border-radius: 5px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    position: absolute;
    overflow-x: hidden;
    max-height: 0;
    visibility: hidden;
    transition: max-height 0.8s;
    z-index: 9;
    &.show {
      max-height: 250px;
      overflow-x: scroll;
      visibility: visible;
    }
  }

  .auto-list-item {
    padding: 8px 10px;
    font-size: 1em;
    color: $lp-text;
    border-bottom: 1px dashed $lp-border;
    cursor: pointer;
    &:hover {
      background-color: $hover-color;
    }
    span {
      display: block;
    }
    span:nth-child(2) {
      font-size: 0.85em;
      color: $lp-text-2;
    }
  }
}
</style>
